import { AppService } from '@app/app.service';
import { every, findIndex } from 'lodash';
import { Component, Input, OnInit, ElementRef, HostBinding } from '@angular/core';
import { DragulaService } from 'ng2-dragula';
import { GridService } from '@app/edit/grid.service';
import R from 'ramda';
import Section from '@app/section';
import Publication from '@app/publication';

@Component({
  selector: 'app-sections-panel',
  templateUrl: './sections-panel.component.html',
  styleUrls: ['./sections-panel.component.less'],
})
export class SectionsPanelComponent implements OnInit {
  @HostBinding('class._is-expanded') isExpanded = false;
  @Input() activeSections: {sectionId: number, subsectionId: number};
  @Input() publication: Publication;
  thisElement: ElementRef;
  isEditSectionModalShown = false;
  isEditSubsectionModalShown = false;
  sectionIdToAddSubsectionTo: number;

  activateSection(item) {
    const
      firstSubsection = (item.subsections || [{}])[0];

    this.activeSections.sectionId = item.id;
    item.isExpanded = true;

    this.activeSections.sectionId = item.id;

    // If there are subsections make first one active
    if (firstSubsection) {
      this.activeSections.subsectionId = firstSubsection.id;
      this.gridService.setCentralCards(firstSubsection.sources || []);
    } else {
      this.gridService.setCentralCards(item.sources);
    }
  }

  activateSubsection(params) {
    this.activeSections.subsectionId = params.subsection.id;
    this.activeSections.sectionId = params.section.id;
    this.gridService.setCentralCards(params[params.subsection !== null ? 'subsection' : 'section'].sources);
  }

  closeEditSectionModal() {
    this.isEditSectionModalShown = false;
  }

  closeEditSubsectionModal() {
    this.isEditSubsectionModalShown = false;
  }

  constructor(element: ElementRef, public appService: AppService, public gridService: GridService, private dragulaService: DragulaService) {
    dragulaService.setOptions('sections-drag', {
      moves: (el, container, handle) => handle.className === 'drag-icon',
    });

    dragulaService.setOptions('subsections-drag', {
      moves: (el, container, handle) => handle.className === 'drag-icon-subsection',
    });

    this.thisElement = element.nativeElement;
  }

  deleteSection(event, params: {sectionId: number}) {
    event.stopPropagation();

    const
      indexDeletingSection = findIndex(this.publication.sections, {id: params.sectionId});

    if (this.activeSections.sectionId === this.publication.sections[indexDeletingSection].id) {
      this.activateSection(this.publication.sections[indexDeletingSection === 0 ? 1 : indexDeletingSection - 1]);
    }

    this.publication.sections.splice(indexDeletingSection, 1);
    this.appService.deleteSection({sectionId: params.sectionId, publicationId: this.publication.id});
  }

  deleteSubsection(event, params: {section: Section, subsectionId: number}) {
    event.stopPropagation();

    const
      indexDeletingSubsection = findIndex(params.section.subsections, {id: params.subsectionId});

    if (
      params.section.subsections.length > 1 &&
      this.activeSections.subsectionId === params.section.subsections[indexDeletingSubsection].id
    ) {
      this.activateSubsection({
        section   : params.section,
        subsection: params.section.subsections[indexDeletingSubsection === 0 ? 1 : indexDeletingSubsection - 1],
      });
    }

    params.section.subsections.splice(indexDeletingSubsection, 1);
    this.appService.deleteSection({sectionId: params.subsectionId, publicationId: this.publication.id});

    // When delete the last subsection, this.activeSections.subsectionId is reset and parent section becomes active
    if (!params.section.subsections.length) {
      this.activateSection(params.section);
    }
  }

  editSectionName(params) {
    params.event.stopPropagation();
    params.section.isEditable = true;
  }

  ngOnInit() {
    window.addEventListener('click', (event: MouseEvent & {path: Array<{}>}) => {
      if (every(event.path, node => this.thisElement !== node)) {
        this.isExpanded = false;
      }
    });
  }

  openEditSectionModal() {
    this.isEditSectionModalShown = true;
  }

  openEditSubsectionModal(event, id) {
    event.stopPropagation();
    this.sectionIdToAddSubsectionTo = id;
    this.isEditSubsectionModalShown = true;
  }

  togglePanel() {
    this.isExpanded = !this.isExpanded;
  }

  toggleSection(event, item) {
    event.stopPropagation();
    item.isExpanded = !item.isExpanded;
  }}



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/edit/sections-panel/sections-panel.component.ts